import type { ResearchSourceStatus } from '../../../api/salesResearch';

const ICON: Record<ResearchSourceStatus['status'], string> = {
  ok: '✅',
  empty: '⚪',
  not_configured: '⚙️',
  failed: '❌',
};

/**
 * Rendered on every run, including fully successful ones.
 *
 * A brief built from four sources and a brief built from two look identical
 * once written — the second one is just thinner, in ways the reader cannot see.
 * Showing the roster every time is what stops a degraded run from passing as a
 * complete one.
 */
export function SourceStatusList({ statuses }: { statuses: ResearchSourceStatus[] }) {
  if (statuses.length === 0) return null;

  const degraded = statuses.filter((s) => s.status !== 'ok').length;

  return (
    <details className="rounded-md border border-border bg-surface-secondary px-3 py-2" open={degraded > 0}>
      <summary className="cursor-pointer text-body-sm font-medium">
        Sources ({statuses.length - degraded}/{statuses.length} succeeded)
        {degraded > 0 && (
          <span className="ml-2 text-warning-dark">· {degraded} degraded or unavailable</span>
        )}
      </summary>
      <ul className="mt-2 space-y-1">
        {statuses.map((s, i) => (
          <li key={`${s.name}-${i}`} className="text-body-sm">
            <span className="mr-1.5">{ICON[s.status]}</span>
            <span className="font-medium">{s.name}</span>
            <span className="text-text-tertiary">: {s.detail}</span>
          </li>
        ))}
      </ul>
    </details>
  );
}
